(function () {
  function initHeroWell(hero) {
    if (!hero || hero.dataset.heroWellInit === 'true') return;

    var host = hero.querySelector('[data-hero-well-host]');
    var canvas = hero.querySelector('[data-hero-well-canvas]');
    if (!host || !canvas) return;

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    hero.dataset.heroWellInit = 'true';

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 2;
    var H = 2;
    var mx = 0;
    var my = 0;
    var tx = 0;
    var ty = 0;
    var gravity = 1;
    var gravityTarget = 1;
    var lastTx = 0;
    var lastTy = 0;
    var follow = 0.16;
    var rafId = null;

    function clientToLocal(clientX, clientY) {
      var hr = host.getBoundingClientRect();
      return {
        x: Math.max(0, Math.min(W, clientX - hr.left)),
        y: Math.max(0, Math.min(H, clientY - hr.top))
      };
    }

    function rgbLerp(a, b, t) {
      return (
        'rgb(' +
        Math.round(a[0] + (b[0] - a[0]) * t) +
        ',' +
        Math.round(a[1] + (b[1] - a[1]) * t) +
        ',' +
        Math.round(a[2] + (b[2] - a[2]) * t) +
        ')'
      );
    }

    function wellWeight(u) {
      if (u >= 1) return 0;
      var funnel = Math.pow(1 - u, 2.7);
      var neck = Math.exp(-((u / 0.13) * (u / 0.13))) * 0.9;
      return Math.min(1.6, funnel + neck);
    }

    function mapPoint(a, u, R, sinkBase, anchorX, anchorY) {
      var w = wellWeight(u) * gravity;
      var w0 = Math.max(0.0001, wellWeight(0) * gravity);
      var r = u * R;
      var centerFollow = Math.pow(Math.max(0, 1 - u), 2.2);
      var cx = anchorX + (mx - anchorX) * centerFollow;
      var cy = anchorY + (my - anchorY) * centerFollow;
      var squash = 0.42 + u * 0.58;
      var sag = sinkBase * (w / w0 - 1);
      var x = cx + Math.cos(a) * r;
      var y = cy + Math.sin(a) * r * squash + sag;
      return [x, y];
    }

    function resize() {
      var r = host.getBoundingClientRect();
      W = Math.max(2, Math.floor(r.width));
      H = Math.max(2, Math.floor(r.height));
      canvas.width = Math.floor(W * dpr);
      canvas.height = Math.floor(H * dpr);
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      tx = Math.min(W - 1, Math.max(1, tx));
      ty = Math.min(H - 1, Math.max(1, ty));
    }

    function drawFrame() {
      ctx.clearRect(0, 0, W, H);

      var R = Math.hypot(W, H) * 0.72;
      var rings = Math.max(22, Math.min(48, Math.round(Math.min(W, H) / 20)));
      var spokes = Math.max(28, Math.min(70, Math.round(W / 24)));
      var sinkBase = Math.min(W, H) * 0.13;
      var anchorX = W * 0.52;
      var anchorY = H * 0.38;

      var glow = ctx.createRadialGradient(mx, my, 0, mx, my, R * 0.7);
      glow.addColorStop(0, 'rgba(155, 143, 212, 0.10)');
      glow.addColorStop(0.42, 'rgba(184, 218, 245, 0.05)');
      glow.addColorStop(1, 'rgba(246, 245, 255, 0)');
      ctx.fillStyle = glow;
      ctx.fillRect(0, 0, W, H);

      ctx.lineWidth = 0.72;
      ctx.lineJoin = 'round';
      for (var i = 1; i <= rings; i++) {
        var u = i / rings;
        var col =
          u < 0.36
            ? rgbLerp([78, 70, 132], [106, 132, 194], u / 0.36)
            : rgbLerp([106, 132, 194], [172, 206, 235], (u - 0.36) / 0.64);
        ctx.strokeStyle = col.replace('rgb(', 'rgba(').replace(')', ',0.36)');
        ctx.beginPath();
        for (var s = 0; s <= spokes; s++) {
          var a = (s / spokes) * Math.PI * 2;
          var p = mapPoint(a, u, R, sinkBase, anchorX, anchorY);
          if (s === 0) ctx.moveTo(p[0], p[1]);
          else ctx.lineTo(p[0], p[1]);
        }
        ctx.closePath();
        ctx.stroke();
      }

      ctx.strokeStyle = 'rgba(48, 45, 84, 0.30)';
      ctx.lineWidth = 0.55;
      for (var s2 = 0; s2 < spokes; s2++) {
        var a2 = (s2 / spokes) * Math.PI * 2;
        ctx.beginPath();
        for (var i2 = 0; i2 <= rings; i2++) {
          var u2 = i2 / rings;
          var p2 = mapPoint(a2, u2, R, sinkBase, anchorX, anchorY);
          if (i2 === 0) ctx.moveTo(p2[0], p2[1]);
          else ctx.lineTo(p2[0], p2[1]);
        }
        ctx.stroke();
      }

      ctx.strokeStyle = 'rgba(56, 52, 96, 0.42)';
      ctx.fillStyle = 'rgba(56, 52, 96, 0.18)';
      ctx.lineWidth = 0.85;
      var throat = Math.max(8, Math.min(26, 12 * gravity));
      ctx.beginPath();
      ctx.ellipse(mx, my, throat * 1.45, throat * 0.9, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
    }

    function setTargetFromEvent(e) {
      var p = clientToLocal(e.clientX, e.clientY);
      var vx = p.x - lastTx;
      var vy = p.y - lastTy;
      var speed = Math.sqrt(vx * vx + vy * vy);
      tx = p.x;
      ty = p.y;
      lastTx = p.x;
      lastTy = p.y;
      gravityTarget = Math.max(0.75, Math.min(1.95, 0.92 + speed * 0.045));
    }

    function loop() {
      mx += (tx - mx) * follow;
      my += (ty - my) * follow;
      gravity += (gravityTarget - gravity) * 0.08;
      drawFrame();
      rafId = requestAnimationFrame(loop);
    }

    function kick() {
      resize();
      tx = W * 0.52;
      ty = H * 0.38;
      gravityTarget = 1;
      gravity = 1;
      mx = tx;
      my = ty;
      lastTx = tx;
      lastTy = ty;
      requestAnimationFrame(function () {
        resize();
        drawFrame();
      });
    }

    function onResize() {
      requestAnimationFrame(resize);
    }

    kick();
    loop();

    window.addEventListener('resize', onResize);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onResize);
    if (window.ResizeObserver) new ResizeObserver(onResize).observe(hero);

    hero.addEventListener('mousemove', setTargetFromEvent, { capture: true });
    hero.addEventListener('mouseenter', setTargetFromEvent, { capture: true });
    hero.addEventListener('mouseleave', function () {
      tx = W * 0.52;
      ty = H * 0.38;
      gravityTarget = 1;
    });
    hero.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches && e.touches[0]) setTargetFromEvent(e.touches[0]);
      },
      { capture: true, passive: true }
    );
    hero.addEventListener(
      'touchmove',
      function (e) {
        if (e.touches && e.touches[0]) setTargetFromEvent(e.touches[0]);
      },
      { capture: true, passive: true }
    );

    hero.addEventListener('shopify:section:unload', function () {
      if (rafId) cancelAnimationFrame(rafId);
      hero.dataset.heroWellInit = '';
    });
  }

  function boot() {
    document.querySelectorAll('.stellar-hero').forEach(function (hero) {
      if (!hero.querySelector('[data-hero-well-canvas]')) return;
      initHeroWell(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var hero = event.target.querySelector('.stellar-hero');
    if (hero && hero.querySelector('[data-hero-well-canvas]')) initHeroWell(hero);
  });
})();
